import PropTypes from 'prop-types';
import s from './CatImage.module.css';

const CatImage = ({ imageUrl }) => {
  return (
    <div>
      <img src={imageUrl} className={s.catImage} alt={'cat'} />
    </div>
  );
};

export { CatImage };

CatImage.propTypes = {
  imageUrl: PropTypes.string.isRequired,
};
